import { CreateSchedulePayload } from "../../../../../types";
import axios from "../../axios";
import * as Requests from "../../requests";

export const createWorkingHoursScheduleApi = (token: string, payload: CreateSchedulePayload) => {
    return axios.post(Requests.CREATE_SCHEDULE_API, { ...payload }, {
        headers: { token },
        baseURL: process.env.PICKUP_ENDPOINTS,
    });
};